import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Box from '@material-ui/core/Box';

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import {CustomDateTimePicker, CustomSwitch} from "../../elements";
import { getLocaleDateTimeString } from 'i18n';
import DateRangeIcon from '@material-ui/icons/DateRange';
import i18next from 'i18next';
import { FormControlLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

    formFields: {
        height: '100%',
        width: '100%',
        paddingTop: '50px',
    },
    errorMessage: {
        fontSize: 13,
        color: theme.palette.primary.red,
    },
}));

function ParkingPaymentParam(props) {
    const classes = useStyles();

    const {
        handleChange,
        updatedParking,
        handleTemplate,
        error,
        readOnly,
        templates
    } = props;

    const {t} = useTranslation();
    const [templateValues, setTemplateValues] = useState([]);
    
    useEffect(() => {
        if (templates) {
            setTemplateValues(templates.map(a => {
                return {value: a.parkingTemplateId, label: a.name, key: a.parkingTemplateId}
            }));
        }
    }, [templates]);

    const getTemplateValue = (templateId) => {
        if (templateId) {
            const p = templateValues && templateValues.find(b => b.value == templateId);
            if (!p) {
                return {label: 'Not Found', value: templateId};
            }
            return p;
        }
        return null;
    }

    const getTemplate = (templateId) => {
        if (templateId) {
            const p = templates && templates.find(b => b.parkingTemplateId == templateId);
            return p;
        }
        return null;
    }

    const getSelectValue = (selectId, values, multipleValues) => {
        if ( selectId ) {
            if ( multipleValues ) {
                let tmp = [];
                for ( let i=0; i<selectId.split(',').length; i++) {
                    let tmp2 = values.find(a => a.id==selectId.split(',')[i]);
                    tmp.push({value: tmp2.id, label: t(tmp2.value), key: tmp2.id});
                }
                return tmp;
            } else {
                let tmp = values.find(a => a.id==selectId);
                return {value: tmp.id, label: t(tmp.value), key: tmp.id}
            }
        }
        if ( multipleValues )
            return [];
        else
            return null;
        
    }

    const getSelectValues = (values) => {
        if ( values ) {
            return values.map(a => {
                return {value: a.id, label: t(a.value), key: a.id}
            })
        }
        return null;
    }

    const getComponent = (templateParam) => {
        switch (templateParam.type) {
            case 'PARAM_TYPE_SELECT':
                return <Autocomplete
                    id={templateParam.parkingTemplateParamId}
                    multiple={templateParam.multiple}
                    value={getSelectValue(updatedParking.templateParams[templateParam.position-1], templateParam.values, templateParam.multiple)}
                    disabled={readOnly}
                    disableClearable
                    onChange={(event, newValue) => { handleChange('templateParams_'+(templateParam.position-1), newValue)(newValue) }}
                    forcePopupIcon={false}
                    filterSelectedOptions
                    options={getSelectValues(templateParam.values)}
                    getOptionLabel={(option) => {
                        return option.label;
                    }}
                    style={{width: '100%'}}
                    renderInput={(params) => (
                        <TextField {...params} label={t(templateParam.name)} required fullWidth
                            helperText={error && error['templateParams_'+templateParam.position]
                                ? <span
                                    className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                : null}
                            InputProps={{...params.InputProps,}}
                        />
                    )}
                    size="small"
                />

            case 'PARAM_TYPE_DATE':
                return  <CustomDateTimePicker
                    pure={true}
                    fullWidth
                    label={t(templateParam.name)}
                    required={templateParam.required}
                    disabled={readOnly}
                    value={updatedParking.templateParams[templateParam.position-1] ? updatedParking.templateParams[templateParam.position-1] : null}
                    icon={<DateRangeIcon/>}
                    handleChange={(event, newValue) => { handleChange('templateParamsD_'+(templateParam.position-1), newValue)(event) }}
                    format={getLocaleDateTimeString(i18next.language)}
                    helperText={error && error['templateParams_'+templateParam.position]
                        ?
                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                        : null}
                > </CustomDateTimePicker>
            case 'PARAM_TYPE_TEXT':
                return  <TextField
                    type="text"
                    helperText={error && error['templateParams_'+templateParam.position]
                        ?
                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                        : null}
                    fullWidth
                    required={templateParam.required}
                    disabled={readOnly}
                    id={templateParam.position+'_'+templateParam.name}
                    value={updatedParking.templateParams[templateParam.position-1] ? updatedParking.templateParams[templateParam.position-1] : ''}
                    onChange={(event, newValue) => { handleChange('templateParams_'+(templateParam.position-1), newValue)(event) }}
                    label={t(templateParam.name)}
                />
            case 'PARAM_TYPE_NUMBER':
                return  <TextField
                    type="number"
                    helperText={error && error['templateParams_'+templateParam.position]
                        ?
                        <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                        : null}
                    fullWidth
                    required={templateParam.required}
                    disabled={readOnly}
                    id={templateParam.position+'_'+templateParam.name}
                    value={updatedParking.templateParams[templateParam.position-1] ? updatedParking.templateParams[templateParam.position-1] : ''}
                    onChange={(event, newValue) => { handleChange('templateParams_'+(templateParam.position-1), newValue)(event) }}
                    label={t(templateParam.name)}
                />
            case 'PARAM_TYPE_BOOLEAN':
                return <FormControlLabel 
                    control={<CustomSwitch color="secondary"                    
                        disabled={readOnly}
                        checked={updatedParking.templateParams[templateParam.position-1] ? 
                            ( updatedParking.templateParams[templateParam.position-1]==="false" ? false : true ) : false}
                        handleSwitch={(event, newValue) => { handleChange('templateParamsB_'+(templateParam.position-1), newValue)(event) }}
                        helperText={error && error['templateParams_'+templateParam.position]
                            ?
                            <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                            : null}
                    />}
                    label={<span
                        style={{
                            fontWeight: 400,
                            fontSize: '14px',
                            color: 'rgba(0, 0, 0, 0.54)',
                        }}>{t(templateParam.name)}</span>}
                />
        }
    }

    return (
        <div className={classes.formFields}>
            <form autoComplete='off'>
                <Box mb={2} height="100%">
                    <Grid container spacing={2} >
                        <Grid container spacing={2} sm={12} style={{marginLeft: "auto", marginRight: "auto"}}>
                            <Grid item sm={6}>
                                <Autocomplete
                                    value={getTemplateValue(updatedParking.templateId)}
                                    disabled={readOnly}
                                    disableClearable
                                    onChange={(event, newValue) => {
                                        handleTemplate(getTemplate(newValue.value));
                                    }}
                                    forcePopupIcon={false}
                                    filterSelectedOptions
                                    options={templateValues}
                                    getOptionLabel={(option) => {
                                        return option.label;
                                    }}
                                    style={{width: '100%'}}
                                    renderInput={(params) => (
                                        <TextField {...params} label={t('TEMPLATE')} required fullWidth
                                            helperText={error && error.subjectId
                                                ? <span
                                                    className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                                : null}
                                            InputProps={{...params.InputProps,}}

                                        />
                                    )}
                                    size="small"
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} sm={12} style={{marginLeft: "auto", marginRight: "auto"}}>
                            {getTemplate(updatedParking.templateId) && getTemplate(updatedParking.templateId).params && getTemplate(updatedParking.templateId).params.map((templateParam) => (
                                <Grid item sm={6}>
                                    {getComponent(templateParam)}
                                </Grid>
                            ))}
                        </Grid>

                    </Grid>
                </Box>
            </form>
        </div>
    )
}

ParkingPaymentParam.propTypes = {};
ParkingPaymentParam.defaultProps = {};

const mapStateToProps = (store) => ({
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ParkingPaymentParam);


